import React, { useEffect, useState } from "react";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import RoomOutlinedIcon from "@material-ui/icons/RoomOutlined";
import { useData } from "../../../components/firebase/DataProvider";
import { FieldValue } from "../../../components/firebase/FirebaseProvider";
import Gap from "../../../components/Gap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import NavigateNextIcon from "@material-ui/icons/NavigateNext";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import useStyles from "./style";
import AlamatDialog from "../Alamat/AlamatDialog";
import { DialogTitle, Divider, IconButton, Radio } from "@material-ui/core";
import ListAlamat from "./listAlamat";
import { useSnackbar } from "notistack";

function Alamat({ id, subcart }) {
  const classes = useStyles();
  const { alamat, cartRef, profil, cart } = useData();
  const { enqueueSnackbar } = useSnackbar();
  const [dialog, setDialog] = useState({
    open: false,
    action: "",
  });
  const [dialogEdit, setDialogEdit] = useState({
    open: false,
  });

  const [selectedAlamat, setSelectedAlamat] = useState({});
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (subcart?.checked) {
      setChecked(subcart?.checked === "N" ? false : true);
    }
  }, [subcart]);

  useEffect(() => {
    if (id) {
      const findAlamat = alamat.find((al) => al.id === id);
      if (findAlamat) {
        setSelectedAlamat(findAlamat);
      }
    }
  }, [id, alamat]);

  const handleChangeAlamat = async (newAlamat) => {
    setLoading(true);
    const newId = newAlamat.id;
    let dataProdukAlamatBaru = Object.values(
      cart?.subcarts?.[newId]?.products ?? {}
    );
    let dataProdukAlamatLama = Object.values(
      cart?.subcarts?.[id]?.products ?? {}
    );

    if (id === newId) {
      setLoading(false);
      setOpen(false);
      return;
    }

    if (
      dataProdukAlamatBaru?.length > 0 &&
      dataProdukAlamatBaru?.[0]?.type !== dataProdukAlamatLama?.[0]?.type
    ) {
      setLoading(false);
      return enqueueSnackbar(
        "Silahkan pilih alamat lain. Produk normal tidak bisa digabungkan dengan produk Pre-order",
        { variant: "warning" }
      );
    }

    try {
      const subcartProducts = (products) => {
        let oldProducts = {};
        Object.keys(products).forEach((elm) => {
          oldProducts = {
            ...oldProducts,
            [elm]: {
              jumlah: FieldValue.increment(products[elm].jumlah),
              nama: products[elm].nama,
              product: products[elm].product,
              promo: products[elm].promo,
              type: products[elm].type,
              start_preorder:
                products[elm].start_preorder ?? FieldValue.delete(),
            },
          };
        });
        setLoading(false);
        return oldProducts;
      };

      const data = {
        subcarts: {
          [id]: FieldValue.delete(),
          [newId]: {
            //  ...subcart,
            products: subcartProducts(subcart.products),
            length: subcart.length,
            height: subcart.height,
            width: subcart.width,
            created_at: subcart.created_at,
            total_pembayaran: FieldValue.increment(subcart?.total_pembayaran),
            total_tagihan_harga_normal: FieldValue.increment(
              subcart.total_tagihan_harga_normal
            ),
            total_tagihan: FieldValue.increment(subcart.total_tagihan),
            berat_total: FieldValue.increment(subcart.berat_total),
          },
        },
        updated_at: FieldValue.serverTimestamp(),
      };
      await cartRef.set(data, { merge: true });

      setOpen(false);
    } catch (e) {
      // setLoading(false);
      console.log(e.message);
    }
    setLoading(false);
  };

  const handleChecked = async (event) => {
    setChecked(event.target.checked);

    const cartLama = Object.entries(cart?.subcarts ?? {})?.filter(
      ([key, val]) => val?.checked === "Y"
    );

    const dataAlamatLain = Object.values(
      Object.values(cart?.subcarts ?? {}).filter(
        (item) => item?.checked === "Y"
      )?.[0]?.products ?? {}
    )?.[0]?.type;

    const DataAlamatini = Object.values(subcart?.products ?? {})?.[0]?.type;

    if (!checked && dataAlamatLain !== DataAlamatini) {
      cartLama?.map(async ([key, val]) => {
        await cartRef.set(
          {
            subcarts: {
              [key]: {
                checked: "N",
                asuransi_pengiriman: 0,
                biaya_pengiriman: 0,
                biaya_pengiriman_before: 0,
                pengiriman: FieldValue.delete(),
                resi_otomatis_mp: FieldValue.delete(),
                resi_otomatis_mp_kurir: FieldValue.delete(),
                resi_otomatis_mp_resi: FieldValue.delete(),
                resi_otomatis_mp_file: FieldValue.delete(),
              },
            },
            updated_at: FieldValue.serverTimestamp(),
          },
          { merge: true }
        );
      });
    }

    const data = {
      subcarts: {
        [id]: {
          checked: checked ? "N" : "Y",
          asuransi_pengiriman: 0,
          biaya_pengiriman: 0,
          biaya_pengiriman_before: 0,
          pengiriman: FieldValue.delete(),
          resi_otomatis_mp: FieldValue.delete(),
          resi_otomatis_mp_kurir: FieldValue.delete(),
          resi_otomatis_mp_resi: FieldValue.delete(),
          resi_otomatis_mp_file: FieldValue.delete(),
        },
      },
      updated_at: FieldValue.serverTimestamp(),
    };
    await cartRef.set(data, { merge: true });
  };

  return (
    <>
      <div>
        <div className={classes.wrapPilihSemua}>
          <Checkbox
            checked={checked}
            onChange={handleChecked}
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
          />
          <Typography className={classes.liquidPrimary}>
            Pilih Orderan
          </Typography>
        </div>
        <Divider style={{ height: "5px", backgroundColor: "#5675D3" }} />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            cursor: "pointer",
          }}
          onClick={() => setOpen(true)}
        >
          <div style={{ display: "flex", padding: "10px" }}>
            <div style={{ marginRight: "10px" }}>
              <RoomOutlinedIcon />
            </div>
            <div>
              <Typography className={classes.liquidPrimaryBold}>
                Alamat Pengiriman
              </Typography>
              {selectedAlamat?.nama_penerima ? (
                <>
                  <Typography className={classes.liquidSmall}>
                    {selectedAlamat?.nama_penerima} {selectedAlamat?.no_telepon}
                  </Typography>
                  <Typography className={classes.liquidSmall}>
                    {selectedAlamat?.alamat_lengkap}, Kec.{" "}
                    {selectedAlamat?.kecamatan?.name}, Kel.{" "}
                    {selectedAlamat?.kelurahan?.name}, Kota{" "}
                    {selectedAlamat?.kota?.name},{" "}
                    {selectedAlamat?.provinsi?.name}
                  </Typography>
                </>
              ) : (
                <Typography className={classes.liquidSmall}>
                  Alamat Pengiriman Belum Dipilih
                </Typography>
              )}
            </div>
          </div>
          <div style={{ alignSelf: "center", marginRight: "10px" }}>
            <NavigateNextIcon />
          </div>
        </div>
      </div>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
      >
        <DialogTitle>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <IconButton
                size="small"
                onClick={() => setOpen(false)}
                style={{ marginRight: 15 }}
              >
                <ArrowBackIcon />
              </IconButton>
              <Typography>Pilih Alamat</Typography>
            </div>
            <div style={{ cursor: "pointer" }}>
              <Typography
                onClick={() => setDialogEdit({ open: true })}
                color="primary"
              >
                EDIT
              </Typography>
            </div>
          </div>
        </DialogTitle>
        {/* <Header
          onClick={() => setOpen(false)}
          type="with-title"
          title="Pilih Alamat"
        /> */}
        <DialogContent dividers style={{ padding: 10 }}>
          <List>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              disabled={loading}
              onClick={() => setDialog({ open: true, action: "add" })}
            >
              Tambah Alamat
            </Button>
            <Gap height={10} />
            {alamat?.length > 0 ? (
              alamat?.map((item) => {
                return (
                  <>
                    <ListItem button onClick={() => handleChangeAlamat(item)}>
                      <ListItemText
                        primary={
                          <>
                            <Typography
                              style={{ display: "inline" }}
                              color="textPrimary"
                            >
                              {item.nama_penerima}
                            </Typography>
                            <Typography
                              style={{ display: "inline" }}
                              color="error"
                            >
                              {"     "}{" "}
                              {profil?.alamat_utama === item.id
                                ? "[Utama]"
                                : ""}
                            </Typography>
                          </>
                        }
                        secondary={
                          <React.Fragment>
                            {`${item.alamat_lengkap}, ${item.kelurahan.name}, ${item.kecamatan.name}, ${item.kota.name}, ${item.provinsi.name}`}
                          </React.Fragment>
                        }
                      />
                      <ListItemSecondaryAction>
                        <Radio
                          edge="end"
                          disabled={loading}
                          onClick={() => handleChangeAlamat(item)}
                          checked={selectedAlamat.id === item.id ? true : false}
                        />
                      </ListItemSecondaryAction>
                    </ListItem>
                    <Divider style={{ margin: "0px -5px" }} />
                  </>
                );
              })
            ) : (
              <div>
                <p>Tidak ada data</p>
              </div>
            )}
          </List>
          {/* <Gap height={50} /> */}
        </DialogContent>
        {/* <Fab
          color="primary"
          className={classes.fab}
          onClick={() => setDialogEdit({ open: true })}
        >
          <EditIcon />
        </Fab> */}
      </Dialog>
      <AlamatDialog
        open={dialog.open}
        handleClose={() =>
          setDialog({
            open: false,
          })
        }
      />
      <ListAlamat
        open={dialogEdit.open}
        handleClose={() =>
          setDialogEdit({
            open: false,
          })
        }
      />
    </>
  );
}

export default Alamat;
